import React from 'react'
import {
  Button,
  StepsNextTrigger,
} from '@lightspeed/unified-components-helios-theme/react'
import { FulfilmentType } from '../../../../../../models/fulfilment'
import { OutletSelect } from '../../../../../sale/sale-line-item/fulfilment/OutletSelect/OutletSelect'
import { StepBreadcrumbs } from '../StepBreadcrumbs/StepBreadcrumbs'
import { FulfillmentOutlet, STEPS } from '../types'
import { FulfilmentSelect } from '../../../../../sale/sale-line-item/FulfilmentSelect'
import { OutletToFulfilFrom } from './OutletToFulfilFrom'
import { useStep1Model } from './useStep1Model'

export interface Step1Props {
  onStepChange: (step: STEPS) => void
  onTypeChange: (type: FulfilmentType) => void
  onOutletChange: (outlet: string) => void
  onPerLineFulfilmentOutletChange: (outletId: string | undefined) => void
  perLineFulfilmentOutletId?: string
  type: FulfilmentType
  outlets: FulfillmentOutlet[]
  onClose: () => void
  currentOutlet: string
  totalQuantity: number
}

export const Step1: React.FC<Step1Props> = props => {
  const models = useStep1Model(props)

  return (
    <div className="uc-base w-[640px] max-w-[calc(100vw-2rem)] rounded-lg bg-bg-neutral-top shadow-elevated">
      <StepBreadcrumbs step={STEPS.METHOD} onStepChange={props.onStepChange}>
        <div className="px-8 pt-6">
          <h2 className="typography-heading-md text-fg-neutral-default">
            {models.title}
          </h2>
          <p className="mt-2 typography-body-sm text-fg-neutral-soft">
            {models.description}
          </p>
        </div>
        <div className="space-y-5 px-8 py-5">
          {models.canUseCrossLocationFulfilment && (
            <OutletSelect
              className="vd-mb5"
              includeAvailability={false}
              initialSelectedOutletId={models.initialSelectedOutletId}
              onOutletChange={models.handlePerLineFulfilmentOutletChange}
              onSelectedOutletIdChange={models.handleSelectedOutletIdChange}
              showLabel
            />
          )}
          <FulfilmentSelect
            defaultType={props.type}
            name="fulfilType"
            onTypeChange={props.onTypeChange}
          />
          {models.shouldShowOutletPicker && (
            <OutletToFulfilFrom
              outlets={props.outlets}
              onOutletChange={props.onOutletChange}
              currentOutlet={props.currentOutlet}
            />
          )}
        </div>
        <div className="flex justify-end gap-2 border-t border-border-neutral-soft px-8">
          <Button
            customDataAttributes={{
              container: { 'data-track': 'not-mark-as-unfufilled' },
            }}
            onClick={models.handleClose}
            appearance="secondary"
          >
            {models.closeLabel}
          </Button>
          <StepsNextTrigger>
            <Button
              customDataAttributes={{
                container: { 'data-track': 'next-customer-step' },
              }}
              appearance="primary"
            >
              {models.nextLabel}
            </Button>
          </StepsNextTrigger>
        </div>
      </StepBreadcrumbs>
    </div>
  )
}

Step1.displayName = 'Step1'
